/**
 * The Platform links flagged primary.
 *
 * Returns a list, not a single link: zero primaries and several primaries are
 * both states a submitted set can be in, and the Platform set validator reports
 * each of them distinctly. Callers that need "the" primary Platform of a
 * *validated* set read `primaryPlatformId` off {@link
 * ./platform-set.js#PlatformSetValidation}, where it is guaranteed to exist.
 */
export function primaryPlatformLinks(links) {
    return links.filter((link) => link.isPrimary);
}
/** The distinct Platform identifiers of a set, in first-seen order. */
export function platformIdsOf(links) {
    return [...new Set(links.map((link) => link.platformId))];
}
/**
 * Looks up a master data record by identifier.
 *
 * Returns `undefined` for an unknown identifier rather than throwing: an
 * Initiative referencing a record the master data load did not return is a
 * finding for the rules to report, not a crash.
 */
export function findMasterDataRecord(records, id) {
    return records.find((record) => record.id === id);
}
/**
 * Whether the Identity_Service reports an account active.
 *
 * `undefined` means the snapshot carries no status for that account - unknown to
 * the Identity_Service - which R4.10 treats the same as inactive but reports
 * differently, so the three cases stay distinguishable here.
 */
export function accountIsActive(accounts, userId) {
    return accounts.find((account) => account.userId === userId)?.isActive;
}
//# sourceMappingURL=snapshot.js.map